import styled from 'styled-components';

export const Errors = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 0;
  padding-left: 15px;
  margin-bottom: 8px;
  li {
    font-weight: 500;
    font-size: 13px;
    color: rgb(223, 65, 65);
  }
`;

export const ErrorsWithFundsStyle = styled.div`
  display: flex;
  margin-bottom: 10px;
  position: relative;
  width: fit-content;
  .column {
    min-width: 240px;
    background-color: #f8f9fa;
    position: sticky;
    left: 0;
  }
  .element {
    border-bottom: 1px solid #ff6b6b;
    border-top-width: 0;
    flex: 1;
    min-width: 300px;
    max-width: 300px;
    padding: 0;
    background-color: #fff5f5;
    display: flex;
    flex-direction: column;
    height: 100%;
    p {
      font-size: 14px;
      line-height: 20px;
      padding: 12px 8px;
      margin-bottom: 0;
      background-color: #f8f9fa;
      font-weight: 600;
      border: 1px solid #f1f3f5;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    ul {
      margin: 0;
      padding: 0;
      height: 100%;
      border-left: 1px solid #ff6b6b;
      border-right: 1px solid #ff6b6b;

      li {
        font-weight: 500;
        font-size: 13px;
        color: #ff6b6b;
        list-style: none;
        padding: 8px;
      }
    }
  }
`;

export const StyledTables = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: fit-content;
`;
